import { useState } from 'react';
import Accordion from '../Accordion';
import Tabs from '../Tabs/Tabs';
import Container from '~/grid/Container';
import useIsMobile from '~/hooks/useIsMobile';

/**
 * @param {CmsTabsProps} props
 * @returns {React.ReactElement} The rendered component
 */
const CmsTabs = ({ id, items, isAccordion }) => {
  const isMobile = useIsMobile({ contextKey: 'header' });
  const [activeItems, setActiveItems] = useState([0]);

  /**
   * @param {number} index
   * @param {boolean} isTabs
   */
  const handleOnChange = (index, isTabs) => {
    if (isTabs) {
      setActiveItems([index]);
      return;
    }
    if (activeItems.includes(index)) {
      const indexActive = activeItems.indexOf(index);
      setActiveItems((aI) => {
        const newaI = aI.slice();
        newaI.splice(indexActive, 1);
        return newaI;
      });
    } else {
      setActiveItems((aI) => {
        const newaI = aI.slice();
        newaI.push(index);
        return newaI;
      });
    }
  };

  return (
    <Container id={`cms_tabs_${id}`}>
      <div>
        {!isMobile && !isAccordion && (
          <Tabs
            items={items}
            activeItems={activeItems.slice(0, 1)}
            onChange={(idx) => handleOnChange(idx, true)}
          />
        )}
        {(isAccordion || isMobile) && (
          <Accordion
            items={items}
            activeItems={activeItems}
            onChange={(idx) => handleOnChange(idx, false)}
          />
        )}
      </div>
    </Container>
  );
};

export default CmsTabs;
